/* eslint-disable react/jsx-props-no-spreading */
import cls from "./Upload.module.scss"
import bridge from "@vkontakte/vk-bridge"
import { InputHTMLAttributes, memo } from "react"
import { ReactComponent as Downloads } from "src/shared/assets/icons/downloads.svg"
import { Title } from "src/shared/ui/title/Title"

interface IUploadProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "id" | "type" | "hidden"> {
  img?: string
}

const onClickHandler = () => {
  // @ts-ignore
  bridge.send("VKWebAppSendCustomEvent", {
    event: "upload_photo_click",
  })
}

export const Upload = memo(({ img, ...props }: IUploadProps) => (
  <label htmlFor="upload" className={cls.label}>
    <input type="file" id="upload" hidden accept="image/*" onClick={onClickHandler} {...props} />
    {!img && (
      <>
        <Title className={cls.p}>загрузи</Title>
        <Title className={cls.p}>фото</Title>
        <Downloads />
      </>
    )}
    {img && <img className={cls.img} src={img} alt="img" />}
  </label>
))
